import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import address from './modules/address'
import recommendCode from './modules/recommendCode'

// import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    address,
    recommendCode,
  },
  // getters
})

export default store
